import type { LucideIcon } from "lucide-react";
import {
    Bot,
    Building2,
    Factory,
    FileSearch,
    FileText,
    FileType,
    FolderOpen,
    FormInput,
    Hash,
    Home,
    MessageSquare,
    Network,
    Shield,
    ShieldCheck,
    Sparkles,
    Tags,
    Umbrella,
    Upload,
    User,
} from "lucide-react";

export type AdminSection =
    | "Home"
    | "Management"
    | "Scope Management"
    | "Field Management"
    | "Settings"
    | "AI";

export interface AdminRoute {
    name: string;
    path: string;
    icon: LucideIcon;
    section: AdminSection;
}

export const ADMIN_ROUTES: AdminRoute[] = [
    { name: "Home", path: "home", icon: Home, section: "Home" },
    { name: "Users", path: "users", icon: User, section: "Management" },
    {
        name: "Organizations",
        path: "organizations",
        icon: Building2,
        section: "Management",
    },
    {
        name: "Groups",
        path: "organization-groups",
        icon: Network,
        section: "Management",
    },
    {
        name: "Documents",
        path: "documents",
        icon: FolderOpen,
        section: "Scope Management",
    },
    {
        name: "Clauses",
        path: "clauses",
        icon: FileSearch,
        section: "Scope Management",
    },
    { name: "Topics", path: "topics", icon: Hash, section: "Scope Management" },
    {
        name: "Policy Types",
        path: "policy-types",
        icon: Shield,
        section: "Scope Management",
    },
    {
        name: "Checklists",
        path: "checklists",
        icon: FileText,
        section: "Scope Management",
    },
    {
        name: "Scopes",
        path: "scopes",
        icon: Upload,
        section: "Scope Management",
    },
    {
        name: "Document Section Types",
        path: "document-section-types",
        icon: FileType,
        section: "Scope Management",
    },
    {
        name: "Feedback",
        path: "feedback",
        icon: MessageSquare,
        section: "Scope Management",
    },
    {
        name: "Datatypes",
        path: "datatypes",
        icon: Tags,
        section: "Field Management",
    },
    {
        name: "Fields",
        path: "fields",
        icon: FormInput,
        section: "Field Management",
    },
    {
        name: "Carriers",
        path: "carriers",
        icon: Umbrella,
        section: "Settings",
    },
    {
        name: "Industries",
        path: "industries",
        icon: Factory,
        section: "Settings",
    },
    { name: "Agents", path: "agents", icon: Bot, section: "AI" },
    { name: "Skills", path: "skills", icon: Sparkles, section: "AI" },
    {
        name: "Validators",
        path: "validators",
        icon: ShieldCheck,
        section: "AI",
    },
];

/** All valid section names, in display order. */
export const ADMIN_SECTIONS: AdminSection[] = [
    "Home",
    "Management",
    "Scope Management",
    "Field Management",
    "Settings",
    "AI",
];

/** Routes grouped by section, pre-computed at module load. */
export const ROUTES_BY_SECTION: Map<AdminSection, AdminRoute[]> = new Map(
    ADMIN_SECTIONS.map((section) => [
        section,
        ADMIN_ROUTES.filter((r) => r.section === section),
    ])
);

/** @deprecated Use ROUTES_BY_SECTION instead. Kept for test compatibility. */
export function groupRoutesBySection(): Map<AdminSection, AdminRoute[]> {
    return ROUTES_BY_SECTION;
}
